(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-json-view", [], factory);
	else if(typeof exports === 'object')
		exports["vue-json-view"] = factory();
	else
		root["vue-json-view"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__json_view_index_vue__ = __webpack_require__(2);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__json_view_index_vue__["a" /* default */]);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2ac842d8_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(10);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ac842d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2ac842d8_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("e1788228", content, true, {});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".json-view-container[data-v-2ac842d8]{background-color:#fff}.json-view-container.deep-1[data-v-2ac842d8]{padding-right:10px}.json-view-container .json-view[data-v-2ac842d8]{position:relative;display:block;width:100%;height:100%;white-space:nowrap;padding-left:2rem;box-sizing:border-box;font-family:Consolas!important;cursor:default}.json-view-container .json-view .json-note[data-v-2ac842d8]{color:#909399;font-size:12px;font-style:italic}.json-view-container .json-view .json-key[data-v-2ac842d8]{color:#8c6325}.json-view-container .json-view .json-value[data-v-2ac842d8]{display:inline-block;color:#57b73b;word-break:break-all;white-space:normal}.json-view-container .json-view .json-value.number[data-v-2ac842d8]{color:#2d8cf0}.json-view-container .json-view .json-value.string[data-v-2ac842d8]{color:#57b73b}.json-view-container .json-view .json-value.boolean[data-v-2ac842d8],.json-view-container .json-view .json-value.null[data-v-2ac842d8]{color:#eb3324}.json-view-container .json-view .json-item[data-v-2ac842d8]{margin:0;padding-left:2rem;display:flex}.json-view-container .json-view .first-line[data-v-2ac842d8]{padding:0;margin:0}.json-view-container .json-view .first-line.pointer[data-v-2ac842d8]{cursor:pointer!important}.json-view-container .json-view .json-body[data-v-2ac842d8]{position:relative;padding:0;margin:0}.json-view-container .json-view .json-body .base-line[data-v-2ac842d8]{position:absolute;height:100%;border-left:1px dashed #bbb;top:0;left:2px}.json-view-container .json-view .last-line[data-v-2ac842d8]{padding:0;margin:0}.json-view-container .json-view .angle[data-v-2ac842d8]{position:absolute;display:block;cursor:pointer;float:left;width:20px;text-align:center;left:12px}.json-view-container.one-dark[data-v-2ac842d8]{background-color:#292c33}.json-view-container.one-dark .json-view[data-v-2ac842d8]{font-family:Menlo,Consolas,Courier New,Courier,FreeMono,monospace!important}.json-view-container.one-dark .json-view .json-note[data-v-2ac842d8]{color:#909399;font-size:12px;font-style:italic}.json-view-container.one-dark .json-view .json-key[data-v-2ac842d8]{color:#d27277}.json-view-container.one-dark .json-view .json-value[data-v-2ac842d8]{color:#c6937c}.json-view-container.one-dark .json-view .json-value.number[data-v-2ac842d8]{color:#bacdab}.json-view-container.one-dark .json-view .json-value.string[data-v-2ac842d8]{color:#c6937c}.json-view-container.one-dark .json-view .json-value.boolean[data-v-2ac842d8],.json-view-container.one-dark .json-view .json-value.null[data-v-2ac842d8]{color:#659bd1}.json-view-container.one-dark .json-view .first-line[data-v-2ac842d8]{color:#acb2be}.json-view-container.one-dark .json-view .json-body .base-line[data-v-2ac842d8]{border-left:1px solid #3c4047}.json-view-container.one-dark .json-view .json-item[data-v-2ac842d8],.json-view-container.one-dark .json-view .last-line[data-v-2ac842d8]{color:#acb2be}.json-view-container.vs-code[data-v-2ac842d8]{background-color:#1e1e1e}.json-view-container.vs-code .json-view[data-v-2ac842d8]{font-family:Menlo,Consolas,Courier New,Courier,FreeMono,monospace!important}.json-view-container.vs-code .json-view .json-note[data-v-2ac842d8]{color:#909399;font-size:12px;font-style:italic}.json-view-container.vs-code .json-view .json-key[data-v-2ac842d8]{color:#a9dbfb}.json-view-container.vs-code .json-view .json-value[data-v-2ac842d8]{color:#c6937c}.json-view-container.vs-code .json-view .first-line[data-v-2ac842d8]{color:#d4d4d4}.json-view-container.vs-code .json-view .json-body .base-line[data-v-2ac842d8]{border-left:1px solid #404040}.json-view-container.vs-code .json-view .json-item[data-v-2ac842d8],.json-view-container.vs-code .json-view .last-line[data-v-2ac842d8]{color:#d4d4d4}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(7)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'jsonView',
    props: {
        data: { // 传入的json数据
            type: [Object, Array],
            required: true
        },
        jsonKey: { // json的key值，用于第二层及二层以上的组件的key值
            type: String,
            default: ''
        },
        closed: { // 是否折叠
            type: Boolean,
            default: false
        },
        isLast: { //是否是最后一行
            type: Boolean,
            default: true
        },
        fontSize: { //字体大小
            type: Number,
            default: 14
        },
        lineHeight: { //行高
            type: Number,
            default: 24
        },
        deep: { // 展开深度
            type: Number,
            default: 3
        },
        currentDeep: { // 当前为递归的第几层
            type: Number,
            default: 1
        },
        iconStyle: { // 折叠icon样式
            type: String,
            default: 'square'
        },
        iconColor: { //icon颜色
            type: Array,
            default: function _default() {
                return [];
            }
        },
        theme: { // 主题
            type: String,
            default: ''
        },
        hasSiblings: { // 是否有兄弟节点
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            innerclosed: this.closed,
            templateDeep: this.currentDeep,
            visible: false
        };
    },

    computed: {
        isArray: function isArray() {
            return this.getDataType(this.data) === 'array';
        },
        length: function length() {
            return this.isArray ? this.data.length : Object.keys(this.data).length;
        },
        subfix: function subfix() {
            var data = this.data;
            if (this.isEmptyArrayOrObject(data)) {
                // 如果是空数组或空对象
                return '';
            } else {
                return (this.isArray ? ']' : '}') + (this.isLast ? '' : ',');
            }
        },
        prefix: function prefix() {
            return this.isArray ? '[' : '{';
        },
        items: function items() {
            var _this = this;

            var json = this.data;

            if (this.isArray) {
                return json.map(function (item) {
                    var isJSON = _this.isObjectOrArray(item);
                    return {
                        value: item,
                        isJSON: isJSON,
                        key: ''
                    };
                });
            }
            return Object.keys(json).map(function (key) {
                var item = json[key];
                var isJSON = _this.isObjectOrArray(item);
                return {
                    value: item,
                    isJSON: isJSON,
                    key: key
                };
            });
        },
        iconColors: function iconColors() {
            var theme = this.theme,
                iconColor = this.iconColor;

            if (iconColor.length === 2) {
                return iconColor;
            } else {
                if (theme === 'one-dark') {
                    return ['#747983', '#747983'];
                } else if (theme === 'vs-code') {
                    return ['#c6c6c6', '#c6c6c6'];
                } else {
                    return ['#747983', '#747983'];
                }
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        setTimeout(function () {
            _this2.visible = true;
        }, 0);
    },

    methods: {
        getDataType: function getDataType(data) {
            return Object.prototype.toString.call(data).slice(8, -1).toLowerCase();
        },
        isObjectOrArray: function isObjectOrArray(source) {
            return ['array', 'object'].includes(this.getDataType(source));
        },
        toggleClose: function toggleClose() {
            if (this.length === 0) {
                return;
            }
            if (this.innerclosed) {
                this.innerclosed = false;
            } else {
                this.innerclosed = true;
            }
        },
        isClose: function isClose() {
            return this.templateDeep + 1 > this.deep;
        },
        isEmptyArrayOrObject: function isEmptyArrayOrObject(data) {
            // 空数组或者空对象
            return [{}, []].map(function (item) {
                return JSON.stringify(item);
            }).includes(JSON.stringify(data));
        }
    },
    watch: {
        closed: function closed() {
            this.innerclosed = this.closed;
        }
    }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{class:['json-view-container',_vm.theme,("deep-" + _vm.currentDeep)]},[_c('div',{class:['json-view', _vm.length ? 'closeable' : ''],style:({fontSize:_vm.fontSize+'px',lineHeight:_vm.lineHeight+'px'})},[(_vm.length && _vm.iconStyle==='square')?_c('span',{staticClass:"angle",on:{"click":_vm.toggleClose}},[(_vm.innerclosed)?_c('svg',{staticStyle:{"vertical-align":"middle","color":"rgb(42, 161, 152)","height":"1em","width":"1em"},attrs:{"fill":_vm.iconColors[0],"width":"1em","height":"1em","viewBox":"0 0 1792 1792"}},[_c('path',{attrs:{"d":"M1344 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"}})]):_vm._e(),_vm._v(" "),(!_vm.innerclosed)?_c('svg',{staticStyle:{"vertical-align":"middle","color":"rgb(88, 110, 117)","height":"1em","width":"1em"},attrs:{"fill":_vm.iconColors[1],"width":"1em","height":"1em","viewBox":"0 0 1792 1792"}},[_c('path',{attrs:{"d":"M1344 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.length&& _vm.iconStyle==='circle')?_c('span',{staticClass:"angle",on:{"click":_vm.toggleClose}},[(!_vm.innerclosed)?_c('svg',{staticStyle:{"vertical-align":"middle","color":"rgb(1, 160, 228)","height":"1em","width":"1em"},attrs:{"viewBox":"0 0 24 24","fill":_vm.iconColors[0],"preserveAspectRatio":"xMidYMid meet"}},[_c('path',{attrs:{"d":"M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7"}})]):_vm._e(),_vm._v(" "),(_vm.innerclosed)?_c('svg',{staticStyle:{"vertical-align":"middle","color":"rgb(161, 106, 148)","height":"1em","width":"1em"},attrs:{"viewBox":"0 0 24 24","fill":_vm.iconColors[1],"preserveAspectRatio":"xMidYMid meet"}},[_c('path',{attrs:{"d":"M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.length&& _vm.iconStyle==='triangle')?_c('span',{staticClass:"angle",on:{"click":_vm.toggleClose}},[(!_vm.innerclosed)?_c('svg',{staticStyle:{"vertical-align":"top","color":"#3c4047","height":"1em","width":"1em","padding-left":"2px"},attrs:{"viewBox":"0 0 15 15","fill":_vm.iconColors[0]}},[_c('path',{attrs:{"d":"M0 5l6 6 6-6z"}})]):_vm._e(),_vm._v(" "),(_vm.innerclosed)?_c('svg',{staticStyle:{"vertical-align":"top","color":"#3c4047","height":"1em","width":"1em","padding-left":"2px"},attrs:{"viewBox":"0 0 15 15","fill":_vm.iconColors[1]}},[_c('path',{attrs:{"d":"M0 14l6-6-6-6z"}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-wrap"},[_c('p',{class:['first-line',_vm.length>0?'pointer':''],on:{"click":_vm.toggleClose}},[(_vm.jsonKey)?_c('span',{staticClass:"json-key"},[_vm._v("\""+_vm._s(_vm.jsonKey)+"\": ")]):_vm._e(),_vm._v(" "),(_vm.length)?_c('span',[_vm._v(_vm._s(_vm.prefix)+_vm._s(_vm.innerclosed ? ('...' + _vm.subfix) : '')+"\n                    "),_c('span',{staticClass:"json-note"},[_vm._v(_vm._s(_vm.innerclosed ? (_vm.length+' items') : ''))])]):_vm._e(),_vm._v(" "),(!_vm.length)?_c('span',[_vm._v(_vm._s(("" + (_vm.isArray ? '[]' : '{}') + (_vm.isLast?'':','))))]):_vm._e()]),_vm._v(" "),(!_vm.innerclosed && _vm.length)?_c('div',{staticClass:"json-body"},[_vm._l((_vm.items),function(item,index){return [(item.isJSON)?_c('json-view',{key:index,attrs:{"closed":_vm.isClose(),"data":item.value,"jsonKey":item.key,"currentDeep":_vm.templateDeep+1,"deep":_vm.deep,"iconStyle":_vm.iconStyle,"theme":_vm.theme,"fontSize":_vm.fontSize,"lineHeight":_vm.lineHeight,"iconColor":_vm.iconColors,"isLast":index === _vm.items.length - 1,"hasSiblings":item.hasSiblings}}):_c('p',{key:index,staticClass:"json-item"},[_c('span',{staticClass:"json-key"},[_vm._v(_vm._s((_vm.isArray ? '' : '"' + item.key + '":')))]),_vm._v(" "),_c('span',{class:['json-value',_vm.getDataType(item.value)]},[_vm._v("\n                            "+_vm._s(("" + (_vm.getDataType(item.value)==='string'?'"':'') + (item.value) + (_vm.getDataType(item.value)==='string'?'"':'') + (index ===_vm.items.length - 1 ? '' : ',')))+"\n                        ")])])]}),_vm._v(" "),(!_vm.innerclosed)?_c('span',{staticClass:"base-line"}):_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.innerclosed )?_c('p',{staticClass:"last-line"},[_c('span',[_vm._v(_vm._s(_vm.subfix))])]):_vm._e()])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js